import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const GameEventCreatorContainer = styled.div`
  border-radius: 8px;
  border: 2px dashed #ccc;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.is-loading {
    background: ${theme.colors.GrayF2};
    background: linear-gradient(
      110deg,
      ${theme.colors.SurfacePlatinum20} 8%,
      ${theme.colors.SurfaceCultured10} 18%,
      ${theme.colors.SurfacePlatinum20} 33%
    );
    border: none;
    border-radius: 5px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;
  }

  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }
`;
